module.exports = "/* .row {\n    cursor: pointer;\n  } */\n  \n  .row:hover {\n    background-color: #F8F8F8;\n  }\n  \n  a.nostyle:link {\n    text-decoration: inherit;\n    color: inherit;\n    cursor: pointer;\n}\n  \n  a.nostyle:visited {\n    text-decoration: inherit;\n    color: inherit;\n    cursor: pointer;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/search/search.css
// module id = ./src/app/components/search/search.css
// module chunks = main